/**
 * Angular JS Common Filters:
 *
 * @category Filters
 * @package Common
 * @author Chris <chriswelland@yellostudio.co.uk>
 * @copyright (c) 2016, Yello Studio
 * @version 0.1
 */

(function(){

    'use strict';

    //  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    var RawHtml = function($sce){
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    };

    //  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    var StripTags = function(){
        return function(text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    };

    //  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    var CatFilter = function(){
        return function(articles,cat) {
            
            var out = [];
            if(!cat){ return articles; } // If no category is selected, return all

            articles.forEach(function(article, index){
                if(article.categories.indexOf(cat) > -1){
                    out.push(article);
                }
            });

            return out;
        };
    };

    //  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    var Snip = function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace != -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) == '.' || value.charAt(lastspace-1) == ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    };



    angular.module('App')
        .filter('raw', RawHtml)
        .filter('striptags', StripTags)
        .filter('catFilter', CatFilter)
        .filter('snip', Snip)

        .filter('words', function () {
      return function (input, words) {
          if (isNaN(words)) return input;
          if (words <= 0) return '';
          if (input) {
          var inputWords = input.split(/\s+/);
          if (inputWords.length > words) {
            input = inputWords.slice(0, words).join(' ') + ' …';
          }
          }
          return input;
      };
      })

})();
